// extracted by mini-css-extract-plugin
export default {"about":"About_about__pAIIF","content":"About_content__Q9bVC"};